"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var PrintJob = require('../../PrintJob');

var Highlight = require('./Highlight');

var Space = require('./Space');

function CovidAlert(_ref) {
  var printJob = _ref.printJob;

  if (printJob.is_for_covid) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Highlight, null, "Printer Note: COVID", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Space, {
      n: 1
    }));
  }

  return null;
}

CovidAlert.propTypes = {
  printJob: PropTypes.instanceOf(PrintJob)
};
module.exports = CovidAlert;